import Customers from "./customers";
import Discounts from "./discounts";
import GiftCards from "./gift-cards";
import Emails from "./emails";
import Inventories from "./inventories";
import Listings from "./listings";
import Notes from "./notes";
import OrderAdjustments from "./order-adjustments";
import Orders from "./orders";
import PaymentMethods from "./payment-methods";
import Reports from "./reports";
import ShippingMethods from "./shipping-methods";
import ShoppingCarts from "./shopping-carts";
import Tracking from "./tracking";
import Utilities from "./utilities";
import Prints from "./prints";
import FeatureFlags from "./FeatureFlags";
import facilities from "./facilities";
import ShopifyDiscounts from "@/api/shopify-discounts";

const apis = {
  customers: Customers,
  discounts: Discounts,
  "gift-cards": GiftCards,
  emails: Emails,
  inventories: Inventories,
  listings: Listings,
  notes: Notes,
  orders: Orders,
  "order-adjustments": OrderAdjustments,
  "payment-methods": PaymentMethods,
  reports: Reports,
  "shipping-methods": ShippingMethods,
  "shopping-carts": ShoppingCarts,
  tracking: Tracking,
  utilities: Utilities,
  prints: Prints,
  "feature-flags": FeatureFlags,
  facilities: facilities,
  "shopify-disocunts": ShopifyDiscounts,
};

export const ApiFactory = {
  get: (name) => apis[name],
};
